module.exports = __webpack_public_path__ + "static/media/lease-up-homepoint.6eff3c7f.gif";